import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import logosofofa from '@/images/logo-sofofa.svg'
import logoClaroEmpresas from '@/images/logo-claro-empresas.svg'
const StHeader = styled.header`
  z-index: 2;
  border-bottom-width: 1px;
  background-color: white;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);

  h1 {
    position: relative;
    z-index: 2;
  }

  span {
    letter-spacing: -0.05em;
    display: block;
  }
`

const StLogoSalaWeb = styled.img`
  width: 8rem;
`

const StPresentado = styled.div`
  line-height: 1;
  h1 {
    letter-spacing: 0;
    small {
      margin-bottom: 4px;
    }
    a {
      line-height: 0.5;
    }
  }
`

const Header = ({ siteTitle }) => (
  <StHeader className="fixed top-0 left-0 right-0 border-solid border-gray-300">
    <div className="flex items-center justify-between h-16 mx-auto container sm:px-4 px-2 lg:px-20">
      <StPresentado>
        <h1 className="mr-4">
          <small className="text-xs text-black block uppercase">
            Presentado por:
          </small>
          <img src={logosofofa} />
        </h1>
      </StPresentado>
      <h2>
        <img className="h-14" src={logoClaroEmpresas} />
      </h2>
    </div>
  </StHeader>
)

export default Header
